export const BLOG_CONSTS = {
    BLOG_GET: "BLOG_GET",
    EVENT_GET: "EVENT_GET",
    NEWS_GET: "NEWS_GET",
    GET_TRAVEL: "GET_TRAVEL",
    GET_PROJECT: "GET_PROJECT",
    GET_VIDEO: "GET_VIDEO",
    GET_SEARCH: "GET_SEARCH",
    GET_BLOG_COUNT: "GET_BLOG_COUNT",
};

